import React from "react";
import { Link } from "gatsby";

const MainMenu = ({ data, index }) => {
  const item = data;
  return (
    <div
      className="group hs-dropdown hs-dropdown-toggle [--strategy:static] lg:[--strategy:absolute] [--adaptive:none]"
      index={index}
    >
      <button
        type="button"
        className="lg:h-[145px] relative lg:group-[.open]:after:content-arrowUpIcon after:absolute after:z-50 after:right-0 after:left-0 after:-bottom-4 flex items-center justify-between w-full lg:text-white text-teal font-bold sm:text-lg font-display "
      >
        <span className="drop-shadow-lg">{item.Title}</span>
        <svg
          className="ml-2 sm:w-4 w-3 sm:h-4 h-3 group-[.open]:rotate-180"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
        </svg>
      </button>
      <div className="hs-dropdown-menu transition-[opacity,margin] duration-[0.1ms] sm:duration-[150ms] lg:bg-white hs-dropdown-open:opacity-100 opacity-0 w-full hidden z-10 top-full left-0 min-w-[15rem] rounded-lg py-7 px-7">
        <div className={`grid lg:grid-cols-4 lg:gap-5 gap-y-4 break-words`}>
          {item.menu_sections?.data.map((subitem, subindex) => {
            const isLastItem = subindex === item.menu_sections.length - 1;
            return (
              <div
                index={subindex}
                className={`break-word hs-dropdown relative [--strategy:static] lg:[--strategy:absolute] [--adaptive:none]  pr-5 ${
                  subindex == 3
                    ? "lg:border-0 border-r-0"
                    : "break-word lg:border-r lg:border-gray lg:border-opacity-30"
                }`}
              >
                <h3 className=" flex lg:items-start items-center justify-between gap-y-10 py-2  lg:text-base font-display lg:text-teal text-teal lg:font-bold  ">
                  {subitem.attributes.Heading}
                </h3>
                <div className="menu-items ml-5 lg:ml-0">
                  {subitem.attributes?.Links?.map((nesteditem, i) => {
                    let link = nesteditem.page?.data?.attributes?.Slug;
                    const withHttp = (url) =>
                      !/^https?:\/\//i.test(url) ? `http://${url}` : url;
                    const myUrl = withHttp(nesteditem.ExtLink);
                    return nesteditem.ExtLink !== null ? (
                      <a
                        href={`${myUrl}`}
                        rel="noreferrer"
                        className="block break-words items-center py-2 rounded-md text-base text-black pr-2"
                        target={nesteditem.OpenSameTab ? "_self" : "_blank"}
                      >
                        {nesteditem.Name}
                      </a>
                    ) : (
                      <Link
                        to={`${link ? `/${link}` : "/"}`}
                        className="block break-words items-center py-2 rounded-md text-base text-black pr-2"
                        key={i}
                      >
                        {nesteditem.Name}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};
export default MainMenu;
